import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, FormGroup, FormControl, ValidationErrors } from '@angular/forms';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { OrdersService } from '../../services/orders.service';
import { PurchasingService } from '../../services/purchasing.service';

import { Router } from '@angular/router';
import { Ng2CompleterModule } from 'ng2-completer';
import { Location } from '@angular/common'
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-purchase-order-inquiry',
	templateUrl: './purchase-order-inquiry.component.html',
	styleUrls: ['./purchase-order-inquiry.component.scss']
})
export class PurchaseOrderInquiryComponent implements OnInit {
	@ViewChild('orderView') orderStatusViewRef: ElementRef;
	itemSearchRef = new FormControl('');
	orderSearchRef = new FormControl('');
	limitRef = new FormControl(50);
	vendorSelectRef = new FormControl([]);
	includeInactiveVendors = new FormControl(false);
	searchError = '';
	lastLimit = 50;
	filterresults: any = [];
	filteredItems: any = [];
	customerData: any = [];
	openOrderData: any = [];
	orders: any = [];
	orderSearch: any = [];
	orderResults: any = false;
	ordersFound: any = [];
	activeParent: any = false;

	@Input() name: string;
	color: any = 'blue';
	config: any = [];
	vendors: any[] = [];
	pickinglink: any = '';
	invoicelink: any = '';
	orderdetails: any = false;
	loading = false;
	orderSearchSub: Subscription;

	ngOnInit(): void {
		this.loadVendors();
		this.includeInactiveVendors.valueChanges.subscribe(() => this.loadVendors());
	}

	loadVendors(): void {
		this.purchasingService.getSuppliers('', { inc_disabled: !!this.includeInactiveVendors.value }).subscribe((results: any) => {
			this.vendors = results;
		});
	}

	constructor(private purchasingService: PurchasingService, private globalSearchService: GlobalSearchService, public router: Router, private ordersService: OrdersService, private location: Location, private modalService: NgbModal) {

		this.color = this.globalSearchService.getColor();
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		});
		this.globalSearchService.mesagesallowed.next(false);

		this.pickinglink = this.config.apiServer.baseUrl + this.config.apiServer.pickingLink;
		this.invoicelink = this.config.apiServer.baseUrl + this.config.apiServer.pickingInvoice;
	}

	viewVendor(supplierno: string) {
		this.router.navigate(['/vendors/' + supplierno]);
	}

	viewOrder(orderno: any) {

		this.ordersService.getOrder(orderno).subscribe((order: any) => {
			this.orderdetails = order
			this.modalService.open(this.orderStatusViewRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
		});
	}


	clearForm() {
		this.orderSearchRef.setValue('');
		this.searchError = '';
	}

	/** After a completed search returned zero rows (not initial state, not error). */
	showNoResults(): boolean {
		return (
			!this.loading &&
			!this.searchError &&
			this.orderResults !== false &&
			Array.isArray(this.orderResults) &&
			this.orderResults.length === 0
		);
	}

	public searchOrders() {
		const keyword = String(this.orderSearchRef.value || '').trim();
		const vendors = (this.vendorSelectRef.value || []) as string[];
		const limitRaw = Number(this.limitRef.value);
		const limit =
			Number.isFinite(limitRaw) && limitRaw > 0 ? Math.min(500, Math.floor(limitRaw)) : 50;

		this.searchError = '';

		if (!keyword && (!vendors || vendors.length === 0)) {
			this.searchError = 'Enter keywords and/or select at least one vendor.';
			return;
		}

		if (this.orderSearchSub) {
			this.orderSearchSub.unsubscribe();
		}

		this.loading = true;

		this.orderSearchSub = this.purchasingService
			.getOrderInqSearch({
				keywords: keyword,
				vendors,
				limit,
			})
			.subscribe({
				next: (r: any) => {
					this.loading = false;
					if (r && r.error) {
						this.searchError = r.error;
						this.orderResults = [];
						return;
					}
					const rows = Array.isArray(r) ? r : r.results;
					this.orderResults = rows ?? [];
					this.lastLimit = Array.isArray(r) ? limit : (r.limit != null ? r.limit : limit);
				},
				error: err => {
					console.error('Search failed', err);
					this.loading = false;
					this.searchError = 'Search failed. Try again.';
					this.orderResults = [];
				},
			});
	}


	public onInput(event: any, keys = 'orderno') {

		// this pushes the input value into the service's Observable.

		this.globalSearchService.searchTerm.next(event.target.value);


		const term = event.target.value;
		const allresults = [];
		if (this.openOrderData) {
			this.setFilteredLists(term);
			this.globalSearchService.itemSearch.next(this.ordersFound);
		}


	}

	getOrderedSum(order: any): number {
		let sum = 0;
		for (let i = 0; i < order.details.length; i++) {
			sum += Number(order.details[i].quantityord) || 0;
		}
		return sum;
	}

	getFetSum(order: any): number {
		let sum = 0;
		for (let i = 0; i < order.details.length; i++) {
			sum += Number(order.details[i].fetcharge * order.details[i].quantityord) || 0;
		}
		return sum;
	}

	getReceivedSum(order: any): number {
		let sum = 0;
		for (let i = 0; i < order.details.length; i++) {
			sum += Number(order.details[i].quantityrecd) || 0;
		}
		return sum;
	}

	getNetTotal(order: any): number {
		if (!order || !order.details || !order.details.length) {
			return 0;
		}

		return order.details.reduce((total, item) => {
			return total + (item.quantityrecd * (parseFloat(item.unitprice) + parseFloat(item.fetcharge)));
		}, 0);
	}

	lineNet(det: any): number {
		return det.quantityrecd * (parseFloat(det.unitprice) + parseFloat(det.fetcharge)) ?? 0.00;
	}

	getPoTotal(order: any): number {
		if (!order || !order.details || !order.details.length) {
			return 0;
		}

		return order.details.reduce((total, item) => {
			return total + (item.quantityord * (parseFloat(item.unitprice) + parseFloat(item.fetcharge)));
		}, 0);
	}

	filterOrders(orders) {

		const allresults = [];

		if (this.openOrderData && this.orderSearch) {
			const openorders = this.filterItem(this.openOrderData, '-', 'ORDER_NUMBER');
			if (openorders) {
				openorders.forEach(function(value) {
					if (orders.includes(value.ORDER_NUMBER)) {

						allresults.push({ content: 'Open Order', details: value, link: '/orders/lookup/' + value.ORDER_NUMBER })
					}
				});


			}
		}

		this.setFiltered(allresults)

	}

	setFilteredLists(term) {

		const allresults = [];
		const ordersFound = [];
		if (this.openOrderData) {
			const openorders = this.filterItem(this.openOrderData, term, 'ADDRESS_1,CUST_NAME,ORDER_NUMBER,CUST_ORDER_NO_,DATE_ORDERED,DATE_WANTED,CUST_NUMBER,ITEM_NUMBER');
			if (openorders) {
				openorders.forEach(function(value) {
					allresults.push({ content: 'Open Order', details: value, link: '/orders/lookup/' + value.ORDER_NUMBER })
					ordersFound.push(value.ORDER_NUMBER)
				});
			}
		}

		this.ordersFound = ordersFound;


		this.setFiltered(allresults)

	}
	getValueByType(values: any, value: any) {
		const filtered = false;
		if (typeof values == 'object') {
			if (values) {
				if (values.length) {
					const newfilter = values.filter((r: any) => {
						return r.code == value
					})[0]

					if (newfilter) {
						return newfilter.text
					}
				}
			}
		}
		return 'N/A';
	}

	getFiltered() {
		return this.filteredItems;
	}

	setFiltered(results) {
		this.filteredItems = results;
	}

	assignCopy(input) {
		this.filteredItems = Object.assign([], input);
	}

	filterItem(input, term, keys) {
		if (!term) {
			this.assignCopy(input);
		}
		const result = Object.assign([], input).filter((item) => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(item[key])));
		return result
	}

	navTo(link) {

		this.router.navigate([link]);
	}
	statusStyle(o: any): { [key: string]: string } {
		return {
			background: o.status_color || '#6c757d',
			color: o.status_badge_fg || '#fff',
		};
	}

	back(): void {
		this.location.back()
	}

}